<template>
    <div style="height: 100%;" :style="{ 'background-color': $vuetify.theme.themes.light.backgroundHome }">
      <Relatorios style="height: 100%;"/>
    </div>
</template>

<script>
import Relatorios from '../components/Relatorios/Relatorios'
export default {
  components: { Relatorios }
}
</script>
